// i18n area 'networks' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.ro-RO.meta.json.
import type { enUS } from './networks'

export const roRO: typeof enUS = {
  networks: {
    common: {
      name: 'Nume',
      scope: 'Scope',
      operState: 'Stare',
      actions: 'Acțiuni',
      create: 'Creează',
      close: 'Închide',
      cancel: 'Anulează',
      delete: 'Șterge',
      edit: 'Modifică',
      save: 'Salvează',
      editError: 'Modificarea a eșuat',
      search: 'Caută după nume',
      empty: 'Încă nimic aici',
      saveError: 'Nu s-a putut salva',
      loadError: 'Nu s-a putut încărca — este accesibil backend-ul TVirt?',
      createError: 'Crearea a eșuat',
      deleteError: 'Ștergerea a eșuat',
      deleteConfirmTitle: 'Ștergi {name}?',
      deleteConfirmBody: 'Operațiunea nu este reversibilă.',
      nameHint: 'Litere mici, cifre și cratime (DNS-1123)',
      up: 'Activă',
      down: 'Inactivă',
      unknown: 'Necunoscut',
      usedByVMs: 'VM-uri',
      emptyTable: 'Nicio intrare — adaugă una cu butonul +'
    },
    dialogTabs: {
      general: 'General',
      base: 'Definiție de bază',
      advanced: 'Configurare avansată',
      reserved: 'Intervale rezervate TVirt',
      position: 'Poziție',
      network: 'Configurare de rețea',
      hosts: 'Noduri participante'
    },
    reservedRanges: {
      note: 'Acestea sunt intervalele de IP-uri rezervate TVirt, pe care le poate folosi ca să atribuie automat o adresă VM-urilor, containerelor etc. NOTĂ: IP-urile din aceste intervale nu trebuie folosite în afara TVirt de servicii sau echipamente externe.',
      from: 'De la',
      to: 'Până la'
    },
    overlay: {
      title: 'Rețele overlay',
      createTitle: 'Creează rețea overlay',
      editTitle: 'Modifică rețeaua overlay',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — atribuit automat dacă e gol',
      subnet: 'Subrețea',
      subnetHint: 'CIDR-ul overlay-ului — IPAM își derivă automat intrarea de registru din el',
      mtu: 'MTU',
      weight: 'Pondere',
      ceilMbps: 'Plafon (Mbps)',
      fairnessHint: 'Ponderea contează doar la concurență: pe o legătură liberă fiecare rețea poate folosi toată banda. Plafonul se aplică însă mereu.',
      contention: 'Contenție',
      contentionTip: 'Cel puțin un nod observă pierderi sau overlimit-uri CU coadă pe clasa acestei rețele: lățimea de bandă a uplink-ului este disputată și ponderile acționează. Cât și de când se citesc în seriile net.shaping.* ale nodului.',
      firewallPolicy: 'Politică de firewall',
      hosts: 'Hosturi',
      hostsTitle: 'Noduri participante',
      hostsHint: 'Fiecare nod își declară endpointul de underlay — un select peste adresele REALE ale nodului, citite din configurația lui de rețea; adresa opțională pe overlay trebuie să stea în subrețea. Participarea este constrângerea de plasare.',
      hostNode: 'Nod',
      hostUnderlay: 'IP underlay',
      hostUnderlayPickNode: 'Alege mai întâi nodul',
      hostAddress: 'Adresă pe overlay (opțional)',
      hostAddressOutside: 'În afara subrețelei overlay ({cidr})',
      addHost: 'Adaugă nod',
      observedAt: 'Observat la',
      attachedNics: 'NIC-uri atașate'
    },
    services: {
      title: 'Servicii de rețea',
      createTitle: 'Creează serviciu de rețea',
      editTitle: 'Modifică serviciul de rețea',
      kind: 'Tip',
      kindCategory: 'Servicii',
      selectKindHint: 'Alege tipul serviciului — daemonul de dedesubt este un detaliu de implementare pe care TVirt îl gestionează pentru tine.',
      kindLabel: {
        dhcp: 'Server DHCP',
        ntp: 'Server NTP',
        vpn: 'Server VPN',
        dns: 'Server DNS',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer și reverse proxy',
        floatip: 'IP flotant'
      },
      kindDesc: {
        dhcp: 'Atribuie adrese pe subrețelele servite — pool-urile derivă din subrețeaua, gateway-ul și intervalele rezervate TVirt ale rețelei.',
        dns: 'DNS autoritativ peste zonele declarate — înregistrările derivă din IPAM, plus cele manuale ale tale.',
        gateway: 'Nodul face pe gateway-ul unei rețele — NAT (DNAT, 1:1, SNAT/masquerade) plus rutare statică între rețelele atașate, cu auto-reparare prin design.',
        'lb-rp': 'Load balancer / reverse proxy în fața serviciilor tale — listeneri L4 sau L7 peste pool-uri de membri sau peste instanțele pregătite ale unui Pod, reconfigurați din mers.',
        ntp: 'Serviciul de timp al rețelelor — relay al unor servere upstream externe, sau ceasul nodului servit clienților.',
        vpn: 'Un concentrator VPN pe nod — WireGuard sau OpenVPN, alegi tu: acces la distanță pentru clienții itineranți, sau un tunel site to site între două rețele.',
        floatip: 'O adresă care stă pe o singură instanță App sau Pod sănătoasă la un moment dat și se mută pe următoarea țintă sănătoasă când aceasta cade — failover fără daemoni; echilibrarea rămâne la load balancer.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'IP-ul flotant trăiește în rețeaua aleasă ca adresă SUPLIMENTARĂ în namespace-ul instanței deținătoare: fără porturi, fără echilibrare, fără NAT — IP-ul clientului rămâne real.',
        address: 'IP flotant',
        targets: 'Ținte',
        targetsHint: 'În ordinea PREFERINȚEI: prima țintă sănătoasă deține adresa. Un Pod înseamnă toate instanțele sale, pe replică; fiecare țintă are propriul criteriu de sănătate. Fiecare țintă trebuie atașată la aceeași rețea.',
        targetKind: 'Țintă',
        targetApp: 'Instanță App',
        targetPod: 'Pod (toate instanțele)',
        targetRef: 'Care',
        health: 'Sănătate',
        healthRunning: 'În execuție (fiecare container pregătit)',
        healthTcp: 'Conexiune TCP',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Cale',
        addTarget: 'Adaugă țintă',
        moveUp: 'Mută sus',
        moveDown: 'Mută jos',
        preempt: 'Preempt',
        preemptHint: 'Oprit (implicit): un deținător sănătos păstrează adresa chiar dacă revine o țintă superioară — fără oscilații. Pornit: prima țintă sănătoasă o deține mereu.',
        holder: 'Deținător',
        noHolder: 'nicio țintă sănătoasă',
        since: 'din',
        verdicts: 'Ținte observate',
        healthy: 'sănătoasă',
        unhealthy: 'nesănătoasă',
        noVerdict: 'Încă nedecis — nodul autoritate scrie primul verdict la următoarea sa trecere.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Această instanță deține IP-ul flotant {address} al serviciului {service}'
      },
      poolSource: 'Endpoint-uri',
      poolSourceMembers: 'Membri statici',
      poolSourcePod: 'Instanțele pregătite ale unui Pod',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Endpoint-urile urmează Pod-ul: o instanță intră când rulează cu fiecare container pregătit și iese imediat când este redusă sau moare. Verificarea activă este pornită implicit.',
      poolBackendCount: 'instanțele pregătite ale Pod-ului {pod} pe portul {port}',
      node: 'Nod',
      enabled: 'Activat',
      parked: 'Parcat',
      subnets: 'Subrețele',
      subnetsHint: 'Subrețelele IPAM servite de această instanță — pool-urile derivă din CIDR, gateway și intervalele rezervate TVirt',
      noSubnets: 'Nicio subrețea IPAM — declară mai întâi o rețea logică de fabric (sau o subrețea overlay): IPAM derivă din ele',
      iface: 'Interfață de ascultare',
      ifaceHint: 'Interfața host pe care serviciul își deschide socketul (de ex. un bridge) — obligatorie: un serviciu de rețea este de sine stătător, „toate interfețele” nu mai există',
      dns: 'Servere DNS',
      domain: 'Domeniu',
      detail: 'Servește',
      subnetCount: 'subrețele: {n}',
      zones: 'Zone',
      zonesHint: 'Doar autoritativ — daemonul nu face niciodată recursie. Înregistrările A derivă din adresele declarate ale nodurilor din subrețelele IPAM referențiate; comutatorul reverse servește și zonele in-addr.arpa corespunzătoare (PTR). O zonă este servită de cel mult o instanță DNS în toată flota. Nameserverul opțional este FQDN-ul scris în înregistrările NS/SOA în locul implicitului ns.<zonă>; dacă acesta cade în interiorul zonei, înregistrarea lui A derivă oricum din nodul care servește.',
      zoneName: 'Numele zonei',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'Subrețele IPAM',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Înregistrări manuale',
      zoneRecordsHint: 'Una pe linie: nume TIP valoare — tipuri A, CNAME, MX, TXT. La o coliziune de nume, înregistrarea manuală câștigă în fața celei derivate.',
      addZone: 'Adaugă zonă',
      lbListeningHint: 'Instanța declară O SINGURĂ rețea de ascultare și O SINGURĂ adresă — fiecare listener o leagă pe portul propriu; o a doua adresă înseamnă un al doilea serviciu.',
      listeners: 'Listenere',
      listenersHint: 'Fiecare listener leagă adresa instanței pe portul propriu, în mod L4 (passthrough TCP — octeții nu se deschid niciodată) sau L7 (HTTP), și înaintează către unul dintre pool-urile de mai jos. O pereche adresă/port este servită de cel mult o instanță per nod. Modificările se aplică din mers — fără repornire, fără conexiuni pierdute.',
      listenerName: 'Nume',
      listenerMode: 'Mod',
      modeL7: 'L7 — reverse proxy HTTP',
      modeL4: 'L4 — passthrough TCP',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Adaugă listener',
      pools: 'Pool-uri',
      poolsHint: 'Backend-urile pe care aterizează traficul: membri statici balansați round-robin sau după cel mai puțin ocupat, cu un health check activ opțional care scoate din rotație membrii bolnavi.',
      poolName: 'Nume',
      poolAlgorithm: 'Algoritm',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Cel mai puțin ocupat',
      poolCheck: 'Health check',
      checkNone: 'Niciunul',
      checkTcp: 'Conexiune TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Calea sondei',
      poolInterval: 'Interval (s)',
      poolMembers: 'Membri',
      poolMembersHint: 'Unul pe linie: adresă:port, opțional urmat de o pondere (1-128) — de ex. 10.0.0.21:8080 2',
      addPool: 'Adaugă pool',
      memberCount: 'membri: {n}',
      listen: {
        assignment: 'Atribuire',
        assignmentStatic: 'Adresă statică',
        assignmentAuto: 'Automată (intervale rezervate TVirt)',
        autoHint: 'TVirt extrage adresa din intervalele rezervate ale rețelei logice și o ține sticky — niciodată re-extrasă la un edit sau failover.',
        title: 'Listenere',
        hint: 'Un serviciu de rețea este de sine stătător: fiecare listener își declară rețeaua (overlay, rețea logică de fabric sau interfață) și o adresă în subrețeaua ei — un listener per adresă, wildcard-ul nu mai există. DNS și NTP pot asculta pe mai multe rețele și pe mai multe adrese ale acelor rețele.',
        address: 'Adresă de ascultare',
        add: 'Adaugă listener'
      },
      ntp: {
        mode: 'Mod de sincronizare',
        modeRelay: 'Relay de servere externe',
        modeNodeClock: 'Ceasul nodului',
        modeHint: 'Relay-ul servește ora luată de la serverele upstream declarate; ceasul nodului servește ora nodului care servește — pe care clusterul o ține oricum sincronizată',
        servers: 'Servere upstream',
        serversHint: 'Separate prin virgulă — hostname sau adresă IP; serviciul ia ora de aici și o servește rețelei',
        port: 'Port de ascultare',
        listening: 'Ascultă pe'
      },
      vpn: {
        engine: 'Motor',
        engineHint: 'Alegi tu, și nu se mai schimbă: WireGuard este modern, rapid și în kernel; OpenVPN este veteranul compatibilității (TCP, rețele ostile)',
        engineLocked: 'Motorul este imuabil — alt motor înseamnă un serviciu nou, cheile și certificatele nu sunt portabile',
        mode: 'Mod',
        modeRemote: 'Acces la distanță',
        modeSite: 'Site to site',
        modeHint: 'Accesul la distanță le dă clienților itineranți o adresă în tunel; site to site unește două rețele',
        port: 'Port de ascultare',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard vorbește doar UDP',
        tunnelSubnet: 'Subrețeaua tunelului',
        tunnelSubnetHint: 'Rețeaua în care trăiesc clienții — înregistrată în registrul IPAM, se naște și moare odată cu acest serviciu',
        dnsServers: 'DNS împinse către clienți',
        routes: 'Rute împinse către clienți',
        routesHint: 'Rețele separate prin virgulă, accesibile prin tunel; subrețeaua tunelului este mereu inclusă',
        peers: 'Peeri',
        peersHint: 'Lasă cheia publică goală și TVirt generează perechea — apoi o predă odată cu profilul. Lipește o cheie și peerul o păstrează pe a lui.',
        clients: 'Clienți',
        clientsHint: 'Fiecare client primește un certificat emis de CA-ul propriu al acestui serviciu. Eliminarea unui client îl REVOCĂ: CRL-ul se regenerează imediat.',
        peerName: 'Nume',
        publicKey: 'Cheie publică',
        publicKeyMinted: 'O generează TVirt',
        peerAddress: 'Adresă în tunel',
        peerAddressHint: 'Gol = atribuită',
        allowedIps: 'Subrețele remote',
        allowedIpsHint: 'Separate prin virgulă, rutate prin acest peer',
        endpoint: 'Endpoint',
        presharedKey: 'Cheie pre-partajată',
        keepalive: 'Keepalive (s)',
        addPeer: 'Adaugă peer',
        addClient: 'Adaugă client',
        auth: 'Autentificare',
        authTls: 'Certificate (TLS)',
        remote: 'Endpoint remote',
        remoteHint: 'host:port al capătului îndepărtat — gol înseamnă că această parte așteaptă',
        peerRoutes: 'Subrețele remote',
        serverPublicKey: 'Cheia publică a acestui server',
        ca: 'Autoritate de certificare',
        listening: 'Ascultă pe',
        tunnel: 'Tunel',
        peerCount: 'peeri: {n}',
        download: 'Descarcă profilul',
        downloadError: 'Profilul nu a putut fi exportat',
        lastHandshake: 'Ultimul handshake',
        never: 'niciodată',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Conectat',
        idle: 'Inactiv'
      },
      gateway: {
        attach: 'Tipul rețelei de listening',
        attachOverlay: 'Rețea overlay',
        attachNetwork: 'Rețea logică de fabric',
        attachInterface: 'Interfață brută',
        overlay: 'Rețea overlay',
        network: 'Rețea logică',
        interface: 'Numele interfeței',
        interfaceHint: 'O interfață host pe care TVirt nu o gestionează — adresa este luată de bună',
        address: 'Adresă de listening (gateway)',
        addressHint: 'Adresa de gateway spre care arată clienții — în subrețeaua rețelei de listening',
        dnatTitle: 'Reguli DNAT',
        dnatHint: 'NAT de destinație: traficul care se potrivește este redirecționat către o adresă nouă (și, opțional, un port nou). Orice protocol din listă — porturile acolo unde protocolul le poartă.',
        snatTitle: 'Reguli SNAT',
        snatHint: 'NAT de sursă: traficul care se potrivește iese cu sursa rescrisă — o adresă nouă explicită (și, opțional, un port nou), sau masquerade pe adresa de ieșire dacă e lăsat gol.',
        oneToOneTitle: 'Reguli NAT 1:1',
        oneToOneHint: 'Fiecare pachet pentru adresa externă se mapează pe cea internă, iar hostul intern iese ca cea externă — toate protocoalele, ambele direcții.',
        external: 'Adresă externă',
        internal: 'Adresă internă',
        addOneToOne: 'Adaugă regulă 1:1',
        family: 'Familie',
        protocol: 'Protocol',
        source: 'Sursă (adresă/subrețea)',
        destination: 'Destinație (adresă/subrețea)',
        invert: 'NOT',
        srcPorts: 'Porturi sursă',
        dstPorts: 'Porturi dest.',
        dstPortsHint: 'Port sau interval (80, 8000-8099)',
        toAddress: 'Adresă nouă',
        toPort: 'Port nou',
        snatTo: 'Sursă nouă (gol = masquerade)',
        snatToHint: 'Adresă sursă explicită; gol = masquerade pe adresa de ieșire',
        addDnat: 'Adaugă regulă DNAT',
        addSnat: 'Adaugă regulă SNAT',
        routesTitle: 'Rute statice',
        routesHint: 'Nodul rutează între rețelele la care este atașat (IP forwarding-ul este activ); aceste rute adaugă accesibilitate dincolo de ele — kernel pur, rutarea dinamică vine într-o rundă ulterioară.',
        routeDestination: 'Subrețea de destinație',
        routeGateway: 'Next hop',
        routeMetric: 'Metrică',
        addRoute: 'Adaugă rută',
        listening: 'Ascultă pe',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · rute: {r}'
      },
      unknownSince: 'Necunoscut — ultimul raport acum {m} min',
      lastWord: 'Ultimul cuvânt',
      reportObservedAt: 'Ultimul raport',
      lastErrorRow: 'Ultima eroare',
      recordsCount: 'înregistrări manuale: {n}',
      phase: {
        configured: 'Configurat',
        running: 'În execuție',
        error: 'Eroare'
      },
      authorityNode: 'Authority (atribuire)',
      preferredNode: 'Nod preferat',
      preferredNodeHint: 'O preferință moale, niciodată o constrângere: la următoarea decizie de plasare instanța aterizează aici dacă membrul este eligibil — singură nu mută nimic; mutarea este "Transferă Authority".',
      noPreference: 'Nicio preferință (plasare automată)',
      moving: 'În mișcare',
      movingTooltip: 'Observată aici cât timp Authority-ul atribuie {node}: mutarea converge.',
      placement: {
        title: 'Plasare',
        loading: 'Recensământ în curs…',
        loadError: 'Recensământul de plasare nu a răspuns — reîncearcă mai târziu.',
        draftHint: 'Recensământul se calculează pe atașarea de rețea declarată: va apărea odată ce serviciul există. Crearea este refuzată dacă niciun membru nu îl poate servi, iar refuzul numește mecanismul care a golit mulțimea.',
        eligibleCount: '{n} din {m} membri pot servi această instanță',
        recommended: 'Recomandat',
        eligible: 'Eligibil',
        notEligible: 'Neeligibil',
        blockedReachability: 'rețeaua nu ajunge pe acest membru',
        blockedRequireTag: 'blocat de un tag cerut (requireNodes)',
        blockedExcluded: 'exclus de simulare',
        preferenceUnknown: 'nu (mai) este membru al clusterului',
        preferenceIgnored: 'Preferința "{node}" nu este eligibilă azi: {reason}. Prevalează recomandarea recensământului — niciodată o eroare, serviciul trăiește în altă parte.',
        emptyReachability: 'Niciun membru nu poate servi această instanță: rețeaua nu ajunge nicăieri — nicio retușare a tagurilor nu va ajuta. Cablează nodul sau mută serviciul acolo unde rețeaua există.',
        emptyRequireTag: 'Niciun membru nu poate servi această instanță: tocmai tagurile cerute au golit mulțimea — scoate intrarea din requireNodes sau pune un tag pe un membru.',
        spof: 'Punct unic de defectare',
        spofDetail: 'Un singur membru poate găzdui instanța: la defectare failoverul nu are unde să meargă. Un serviciu multi-listener se mută ca UNITATE — candidatul trebuie să vadă TOATE rețelele lui: acesta este costul.',
        whatIf: 'Simulează membri absenți',
        whatIfHint: 'What-if-ul drain-ului: întreabă ÎNAINTE de evacuare, nu-l descoperi la failover.',
        survives: 'Cu {nodes} absent/absenți, serviciul are încă o casă.',
        notSurvives: 'Evacuarea {nodes} lasă acest serviciu PICAT: constrângerea derivată învinge disponibilitatea (R30) — un daemon viu acolo unde rețeaua nu ajunge nu servește pe nimeni și nu alarmează pe nimeni.',
        transfer: 'Transferă Authority',
        transferError: 'Transferul a eșuat',
        transferTarget: 'Membrul de destinație',
        transferHint: 'Sunt propuși doar membrii eligibili — o preferință în interiorul mulțimii valide, niciodată un override. Niciun task: următoarea trecere a workerilor ESTE mutarea (nodul vechi seceră, cel nou construiește).'
      }
    },
    fabric: {
      tabDerivation: 'Derivare',
      importNetwork: 'Importă din alt fabric',
      importTitle: 'Importă o rețea logică',
      importHint: 'Importul este aderarea explicită: rețeaua rămâne a titularului (aceeași identitate, același stem, același bridge tvf-<stem>) și de aici se mapează pe porturile/LAGG-urile acestui fabric — a mapa ÎNSEAMNĂ a afirma că livrarea ajunge în același domeniu L2 ca a titularului.',
      importPick: 'Rețeaua titularului',
      importNone: 'Nimic de importat: celelalte fabric-uri nu au nicio rețea proprie pe care acest fabric să nu o cunoască deja',
      importedNetworksTitle: 'Rețele importate',
      noImported: 'Nicio rețea importată',
      importedFrom: 'importată din {fabric}',
      importedBy: 'Importată de: {list}',
      importedCount: '+{n} importate',
      owner: 'Titular',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Elimină importul',
      unimportConfirm: 'Elimini importul rețelei {name} (titular {fabric}) din acest fabric? Este refuzat cât timp un port sau LAGG al acestui fabric o mapează, sau un guest, App ori serviciu este deservit doar prin acest picior.',
      unimportRefused: 'Importul este încă în uz — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Acest nod primește deja acea rețea de la alt fabric al cărui membru este: un nod ia o rețea partajată printr-UN singur picior (două uplink-uri ale aceluiași L2 într-un bridge fără STP sunt o buclă). Demapeaz-o pe porturile sau LAGG-ul unuia dintre cele două fabric-uri.',
          otherFabricDerived: 'Documentul poartă blocul unui fabric spre care nodul nu mai declară niciun cablu: aplică mai întâi planul acelui fabric (propune eliminarea dispozitivelor sale), sau preia-le cu take-ownership dacă fabric-ul nu mai există.'
        },
        hint: 'Planul de derivare O.3: pentru fiecare nod cablat starea, diff-ul derivat-vs-curent, topologia de bond DECLARATĂ, flip-urile dual-stack și refuzurile/avertismentele structurate. Doar citire până la apply-ul EXPLICIT — nimic nu aterizează vreodată singur pe un nod.',
        refresh: 'Reîncarcă planul',
        empty: 'Niciun nod nu este cablat la această fabric (și niciunul nu îi mai poartă blocul).',
        refusal: 'Refuz',
        warning: 'Avertisment',
        generation: 'generația documentului {n}',
        state: {
          manual: 'Manual',
          derived: 'Derivat',
          diverged: 'Divergent'
        },
        topologyTitle: 'Topologie declarată',
        members: 'membri',
        primary: 'primar',
        held: 'ținut pe UN singur membru',
        form: {
          perNetworkBond: 'Bond per rețea',
          singleBond: 'Bond unic de rezervă',
          laggBond: 'Bond LACP (LAGG)',
          singlePort: 'Port unic'
        },
        colAction: 'Acțiune',
        colKind: 'Fel',
        colDevice: 'Device',
        colDetail: 'Detaliu',
        action: {
          add: 'adaugă',
          remove: 'elimină',
          replace: 'înlocuiește'
        },
        diffEmpty: 'Niciun diff în așteptare — documentul aplicat coincide cu render-ul.',
        diffBlocked: 'Niciun diff: refuzurile de mai sus blochează acest nod.',
        phasePlanned: 'planificat (pasul 1 din 3)',
        phaseDraining: 'în drenare (pasul 2 din 3)',
        probeUnobserved: 'Sonda de drenare: niciodată raportată — golul este NECUNOSCUT (un retire ar fi refuzat acum).',
        probeFailed: 'Sonda de drenare: observația a EȘUAT — marcajele de timp cunoscute se transportă, niciodată un «gol» pe care nu l-a măsurat nimeni.',
        probeActive: {
          one: 'Sonda: {n} conexiune stabilită încă pe adresa veche',
          few: 'Sonda: {n} conexiuni stabilite încă pe adresa veche',
          other: 'Sonda: {n} de conexiuni stabilite încă pe adresa veche'
        },
        probeLastActive: 'ultima activitate {time}',
        probeEmpty: {
          one: 'Sonda: gol de {n} minut',
          few: 'Sonda: gol de {n} minute',
          other: 'Sonda: gol de {n} de minute'
        },
        probeEmptyUnknown: 'Sonda: gol (de când, necunoscut).',
        impact: '{nics} vNIC și {apps} App pe acest nod folosesc aceste rețele: {list}',
        apply: 'Aplică pe acest nod',
        applyTitle: 'Aplică derivarea — {node}',
        applyIntro: 'Configurația derivată rescrie documentul de rețea al nodului {node} ({n} schimbări) prin aceeași ușă ca editorul host-network — checkpoint NetworkManager și probă onestă incluse. Avertismentele planului de mai jos călătoresc cu actul: citiți-le înainte de a confirma.',
        applyError: 'Apply eșuat',
        applyRefused: 'Nodul a refuzat:',
        planMoved: 'Fabric-ul s-a schimbat după această previzualizare — NIMIC nu a fost aplicat. Planul a fost reîncărcat: priviți din nou și reîncercați.',
        retire: 'Retrage',
        retireTitle: 'Punct fără întoarcere — retragerea {address}',
        restore: 'Restaurează',
        restoreTip: 'Înapoi la instantaneul de dinaintea apply-ului (generația {previous}) — anularea într-un pas (H13)',
        restoreTitle: 'Restaurează documentul anterior — {node}',
        restoreIntro: 'Documentul de rețea al nodului {node} revine la instantaneul luat înaintea ultimului apply (generația {previous}), rescris ca generația {next} în locul celei {current}. Worker-ul îl converge ca pe orice alt document.',
        restoreRedo: 'Documentul înlocuit devine noul instantaneu: restaurarea din nou este redo-ul.',
        restoreClosesChain: 'Instantaneul este documentul manual de dinaintea derivării: lanțul se închide aici — fără altă anulare, nodul rămâne manual până la următorul apply.',
        restoreConfirm: 'Restaurează',
        restoreError: 'Restaurarea a eșuat',
        retireIntro: 'Aceasta elimină {address} ({network}) din {point} definitiv. După acest act, calea înapoi este flip-ul INVERS — redeclararea adresei vechi prin același motor — niciodată o restaurare oarbă.',
        retireOld: 'Adresa veche (eliminată)',
        retireNew: 'Adresa nouă (rămâne)',
        retireEmptyFact: 'Sonda de drenare raportează adresa goală: această eliminare nu taie nicio conexiune observată.',
        retireConfirm: 'Retrage adresa',
        severActiveLoss: {
          one: 'Taie {n} conexiune stabilită încă pe adresa veche — moare cu acest act',
          few: 'Taie {n} conexiuni stabilite încă pe adresa veche — mor cu acest act',
          other: 'Taie {n} de conexiuni stabilite încă pe adresa veche — mor cu acest act'
        },
        severUnknownLoss: 'Acceptă NECUNOSCUTUL: sonda nu a observat niciodată această adresă (sau observația eșuează) — conexiuni vii pot fi tăiate.'
      },
      title: 'Fabric',
      createTitle: 'Creează fabric',
      networks: 'Rețele',
      switches: 'Switch-uri',
      ports: 'Porturi',
      laggs: 'LAGG-uri',
      subnets: 'Subrețele',
      tabOverview: 'Prezentare generală',
      tabNetworks: 'Rețele logice',
      tabSwitches: 'Switch-uri',
      overviewHint: 'Fabricul dintr-o privire: fiecare rețea logică cu MTU-ul și subrețeaua ei (VLAN-urile trăiesc doar în mapările per-port/per-LAGG — aceeași rețea poate călători cu taguri diferite pe porturi diferite). Fabricul este registrul unei infrastructuri EXTERNE — TVirt observă și declară, nu face niciodată provisioning, și atinge doar NIC-urile înregistrate sub controlul lui.',
      absorptionHint: 'Fiecare subrețea declarată aici își DERIVĂ intrarea din registrul IPAM în aceeași scriere — trăiește și moare odată cu rețeaua.',
      scopeFixedHint: 'Scope-ul este fix la rădăcina clusterului: infrastructura fizică este, prin definiție, la nivelul întregului cluster.',
      networksHint: 'Fiecare rețea poartă un MTU obligatoriu (implicit 1500) și o subrețea obligatorie; gateway-ul, serverele DNS și rutele statice declarate aici sunt SURSA UNICĂ pentru NIC-urile serverelor, aplicații și serviciile de rețea.',
      switchesHint: 'Registrul manual: un port este nefolosit, mapat (traficul untagged și cel per tag VLAN pe rețelele logice) sau membru al unui LAGG — un membru nu poartă mapări proprii.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obligatoriu — IPAM își derivă automat intrarea de registru din el',
      nodeAddressing: 'Adresarea nodurilor',
      nodeAddressingNone: 'Niciuna — fără adresă per nod',
      nodeAddressingPool: 'Pool — o adresă fixă pentru fiecare nod deservit',
      nodeAddressingHint: 'Cu Pool, derivarea fabric-ului atribuie fiecărui nod deservit o adresă din intervalele rezervate pentru TVirt (fixă odată atribuită).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Intervale rezervate',
      dns: 'Servere DNS (separate prin virgulă)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway-ul, DNS-ul și rutele declarate aici sunt sursa unică — NIC-urile serverelor, aplicațiile și serviciile de rețea se alimentează de aici',
      routesTitle: 'Rute statice',
      routeDestination: 'Destinație (CIDR)',
      routeVia: 'Via (next hop)',
      portUsed: 'Folosit',
      vlanMappings: 'Mapări VLAN',
      vlanTag: 'Tag VLAN',
      vlanNetwork: 'Rețea logică',
      nameTaken: 'Nume deja folosit în fabric',
      addNetwork: 'Adaugă rețea',
      editNetwork: 'Modifică rețeaua',
      deleteNetwork: 'Elimină rețeaua',
      deleteNetworkConfirm: 'Elimini rețeaua logică {name} din fabric? Subrețeaua ei derivată din IPAM moare odată cu ea (refuzat cât timp un serviciu sau o aplicație o folosește). Mapările de porturi și LAGG care o referențiază sunt curățate.',
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Poziție fizică (opțional) — același vocabular ca la plasarea serverelor; doar declarativă',
      addSwitch: 'Adaugă switch',
      editSwitch: 'Modifică switch-ul',
      deleteSwitch: 'Elimină switch-ul',
      deleteSwitchConfirm: 'Elimini switch-ul {name} cu toate porturile lui? LAGG-urile se restrâng în consecință (și mor sub două porturi).',
      addPort: 'Adaugă port',
      editPort: 'Modifică portul',
      deletePort: 'Elimină portul',
      deletePortConfirm: 'Elimini portul {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:rețea)',
      taggedShort: 'Tagged',
      portCabling: 'Cablare',
      portState: 'Stare',
      stateUnused: 'nefolosit',
      stateMapped: 'mapat',
      laggPortGuard: 'Un port membru al unui LAGG se modifică din partea LAGG-ului',
      laggsTitle: 'LAGG-uri',
      laggsHint: 'Un LAGG înseamnă 2+ porturi în LACP și poate traversa switch-uri (MLAG, transparent); intră doar porturi nefolosite, LAGG-ul este suprafața de mapare, un port eliminat revine la nefolosit.',
      addLagg: 'Adaugă LAGG',
      editLagg: 'Modifică LAGG-ul',
      deleteLagg: 'Elimină LAGG-ul',
      deleteLaggConfirm: 'Elimini LAGG-ul {name}? Porturile lui membre revin la nefolosit.',
      lacpRate: 'Rată LACP',
      laggPorts: 'Porturi membre (2+)',
      laggPortsHint: 'Intră doar porturi nefolosite — eliberează mai întâi portul mapat',
      noNetworks: 'Nicio rețea logică declarată.',
      noSwitches: 'Niciun switch declarat.',
      noLaggs: 'Niciun LAGG declarat.',
      staleConflict: 'Alt operator a modificat acest fabric în timp ce îl editai: salvarea a fost refuzată ca să nu îi ștergi munca. Modificările tale sunt încă aici, intacte. Fabric-ul actualizat a fost deja reîncărcat: confirmă din nou ca să le reaplici peste, sau anulează și vezi ce s-a schimbat.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Doar derivat: fiecare subrețea se naște dintr-o rețea logică de fabric sau dintr-un overlay — se modifică la sursă. Adresele atribuite arată CINE le deține; intervalele rezervate TVirt sunt pool-urile atribuirii automate.',
      search: 'Căutare după nume, CIDR sau adresă',
      empty: 'Nicio rețea — declară o rețea logică de fabric sau o subrețea overlay: IPAM derivă din ele automat.',
      reserved: 'Intervale rezervate TVirt',
      address: 'Adresă',
      origin: 'Proveniență',
      origin_declared: 'declarată',
      origin_observed: 'observată',
      holder: 'Deținută de',
      noAddresses: 'Nicio adresă cunoscută în această subrețea.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Modifică la sursă'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Grupuri firewall',
      createTitle: 'Grup firewall nou',
      editTitle: 'Modifică grupul firewall',
      empty: 'Niciun grup firewall încă — creează unul: un vocabular de reguli reutilizabil, referit de NIC-urile oaspeților după nume.',
      nameHint: 'Litere, cifre și . - _ interioare; unic în interiorul scope-ului său (omonimele din altă parte se disting prin /scope/nume)',
      description: 'Descriere',
      descriptionHint: 'Un rând de intenție, afișat oriunde se alege grupul',
      enforced: 'Impus pe scope',
      enforcedHint: 'Oprit: vocabular pur — regulile leagă doar NIC-urile care referă grupul. Pornit: regulile leagă fiecare NIC de oaspete cu firewallul pornit de sub scope-ul grupului, referit sau nu.',
      enforcedChip: 'Impus',
      enforcedChipHint: 'Regulile leagă fiecare NIC de oaspete cu firewallul pornit de sub scope-ul grupului, referit sau nu',
      enforceWarning: 'Activând impunerea, regulile leagă FIECARE NIC de oaspete cu firewallul pornit de sub {scope} la următoarea convergență, chiar fără referință explicită — iar într-un chain activ drop-ul unui strămoș e definitiv: nivelurile de dedesubt nu îl redeschid.',
      unenforceInfo: 'Scoțând impunerea, regulile rămân doar pe NIC-urile care referă grupul explicit.',
      rules: 'Reguli',
      tabOverview: 'Prezentare generală',
      tabRules: 'Reguli',
      orderHint: 'Ordinea rândurilor ESTE ordinea de evaluare în interiorul grupului: câștigă prima regulă care se potrivește.',
      statefulHint: 'Stateful-ul e implicit: răspunsurile la traficul admis trec de la sine (established/related acceptate, invalid aruncat — le injectează motorul, nu se scriu de mână).',
      noRules: 'Nicio regulă — un vocabular în construcție: a-l referi e legitim și nu produce nimic.',
      addRule: 'Adaugă regulă',
      direction: 'Direcție',
      directionIn: 'Intrare',
      directionOut: 'Ieșire',
      action: 'Acțiune',
      action_accept: 'Acceptă',
      action_drop: 'Aruncă',
      action_reject: 'Respinge',
      protocol: 'Protocol',
      protocolAny: 'Oricare',
      ports: 'Porturi',
      source: 'Sursă',
      dest: 'Destinație',
      comment: 'Comentariu',
      addressHint: 'CIDR IPv4 sau <fabric>/<rețea logică>; gol = oricare',
      moveUp: 'Mută în sus',
      moveDown: 'Mută în jos',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Grupuri firewall',
      nicGroupsPlaceholder: 'Alege un grup…',
      nicGroupsHint: 'Grupurile vizibile, inclusiv cele ale scope-urilor superioare (utilizabile în jos, ca tagurile)',
      nicGroupCount: { one: '{n} grup firewall', few: '{n} grupuri firewall', other: '{n} de grupuri firewall' },
      nicOff: 'Firewall oprit',
      pendingRestartHint: 'Modificările de firewall urmează modelul salvat/aplicat: așteaptă următorul power cycle (PendingRestart). Grupurile impuse de scope-urile superioare se aplică atunci când firewallul NIC-ului e pornit.',
      appConvergeHint: 'Modificările de firewall se aplică la următoarea convergență a containerului. Grupurile impuse de scope-urile superioare se aplică atunci când firewallul e pornit.',
      enforcedAncestors: 'Impuse de scope-urile superioare',
      enforcedAncestorsHint: 'Acest grup se aplică fiecărui NIC de sub scope-ul lui cu firewallul PORNIT — comutatorul e întrerupătorul general al NIC-ului (oprit = niciun chain, strămoși incluși); într-un chain activ autoritatea strămoșului e definitivă: drop-ul lui nu se redeschide dedesubt.'
    }
  }
}
